import React from 'react';
import { TextField } from '@mui/material';

const TextboxCell = (props) => {
    const handleChange = (event) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: event.syntheticEvent,
                value: event.target.value,
            });
        }
    };

    return (
        <td>
            <TextField
                value={props.dataItem[props.field]}
                onChange={handleChange}
            />
        </td>
    );
};

export default TextboxCell;
